import {PostAttendanceTrackerRecord} from '../backend/requests/post-attendance-tracker-record';
import {
  AttendanceTrackerLastRecord,
  AttendanceTrackerRecordRegistration,
} from '../backend/responses/attendance-tracker-record';
import {
  AttendanceTrackerSessionDetails,
  AttendanceTrackerSessions,
} from '../backend/responses/attendance-tracker-session';
import {BackendApiManager} from '../managers/backend-api';

export class EntityAttendanceTrackerRecordsRepository {
  // Singleton Instance
  private static _instance: EntityAttendanceTrackerRecordsRepository;

  static get instance(): EntityAttendanceTrackerRecordsRepository {
    if (!this._instance) {
      this._instance = new EntityAttendanceTrackerRecordsRepository();
    }
    return this._instance;
  }

  // Get the last attendance record of the logged user and the type of the next one
  public async getLastRecord(entityId: string): Promise<AttendanceTrackerLastRecord> {
    const response = await BackendApiManager.instance.get<AttendanceTrackerLastRecord>(
      `/entities/${entityId}/attendance-tracker/me/records/last`
    );

    return response.data;
  }

  // Get the work sessions of the logged user with the entry or the exit in the interval, and the open session
  public async getMySessions(
    entityId: string,
    startDate: string,
    endDate: string
  ): Promise<AttendanceTrackerSessions> {
    const response = await BackendApiManager.instance.get<AttendanceTrackerSessions>(
      `/entities/${entityId}/attendance-tracker/me/sessions?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`
    );

    return response.data;
  }

  // Get a work session of the logged user, by the Id of its entry
  public async getMySession(
    entityId: string,
    sessionId: string
  ): Promise<AttendanceTrackerSessionDetails> {
    const response = await BackendApiManager.instance.get<AttendanceTrackerSessionDetails>(
      `/entities/${entityId}/attendance-tracker/me/sessions/${sessionId}`
    );

    return response.data;
  }

  // Register an attendance record (clock in or clock out) of the logged user
  public async registerRecord(
    entityId: string,
    body: PostAttendanceTrackerRecord
  ): Promise<AttendanceTrackerRecordRegistration> {
    const response = await BackendApiManager.instance.post<AttendanceTrackerRecordRegistration>(
      `/entities/${entityId}/attendance-tracker/me/records`,
      body
    );

    return response.data;
  }
}
